<template>

<HeroSection :featureName="baseFeature.name" :icon="baseFeature.icon">
        <template #title>{{ baseFeature.description }}</template>
        <template #description>
            <p>Simple scan to capture leads from your mobile device. Add additional lead data and notes to enrich your contact information.</p>
            <p class="mt-4">Built into the Company Portals and Event App, no extra logins required.</p>
            
        </template>
        <template #content>
            <div class="w-full relative h-[500px]">
                <div class="absolute top-0 left-0 w-1/2 h-full" >
                    <DeviceWrapper deviceType="phone" :width="80" :z="0" :x="0" :y="12" :rotateOnScroll="true" :imageSrc="appImage" />
                </div>

                <div class="absolute top-0 right-12 w-1/2 h-full" >
                    <DeviceWrapper deviceType="phone" :width="80" :z="0" :x="0" :y="-16" :rotateOnScroll="true" :imageSrc="appMyEvent" />
                </div>

                <div v-reveal class="absolute bottom-0 right-0 w-64 h-64 ">
                    <img src="/src/images/megaphone.svg" alt="Badge" class="w-full h-full object-contain" />
                </div>
            </div>
        </template>
    </HeroSection>

    <AppFeatures :steps="steps" :subheader="baseFeature.name" title="How it works for your Exhibitors" />
    <WorksWith title="Lead Capture" :integrations="integrations" class="mt-12" />
    <Tips title="Lead Capture" :tips="tips" />

</template>


<script setup>
import { ref } from 'vue'
import AppScreen from '@/components/AppScreen.vue'
import HeroSection from '@/components/HeroSection.vue'

import {
    PhoneIcon,
    QrCodeIcon,
    ClipboardDocumentIcon,
    MagnifyingGlassIcon,
    GlobeAltIcon,
    LightBulbIcon,
    BuildingOffice2Icon,
    Squares2X2Icon
} from '@heroicons/vue/24/outline'

import FeatureStep from '@/components/Layouts/FeatureStep.vue';
import SectionHeader from '@/components/Layouts/SectionHeader.vue';
import WorksWith from '@/components/Blocks/WorksWith.vue';
import Tips from '@/components/Blocks/Tips.vue';
import { getFeaturesByIds } from '@/router/features';
import AppFeatures from '@/components/Layouts/AppFeatures.vue';
import DeviceWrapper from '@/components/DeviceWrapper.vue';

const selectedStep = ref(null)

const baseFeature = getFeaturesByIds(['leadcapture'])[0];
const integrations = getFeaturesByIds(['badgesandkiosks', 'companyportals', 'eventapp']);


import appImage from '@/images/screenshots/app/theme-1/profile.png';
import appQualifyingQuestions from '@/images/screenshots/app/theme-1/qualifying-questions.png';
import appLeads from '@/images/screenshots/app/theme-1/leads.png';
import appLeadsPopup from '@/images/screenshots/app/theme-1/lead-popup.png';
import appMyEvent from '@/images/screenshots/app/theme-1/my-event.png';


import appLogin from '@/images/screenshots/app/theme-1/login.png';

const steps = [
    {
        icon: PhoneIcon,
        title: 'Download & Login',
        description: 'Users download the event app and login to get started with lead capture.',
        image: appLogin
    },
    {
        icon: QrCodeIcon,
        title: 'Scan Badges',
        description: 'Quickly scan attendee badges to capture contact information instantly.',
        image: appLeadsPopup
    },
    {
        icon: ClipboardDocumentIcon,
        title: 'Add Lead Qualification',
        description: 'Add additional lead data and notes to enrich your contact information.',
        image: appQualifyingQuestions
    },
    {
        icon: MagnifyingGlassIcon,
        title: 'View, Update & Export',
        description: 'View, filter, update and export your leads immediately from the app or web interface.',
        image: appLeads
    }
]

const tips = [
    'Think about the attendee data you want leads to include and make sure you collect this at time of registration. Exhibitors want more than just name and email.'
]



</script>